import { UseMutateAsyncFunction } from "@tanstack/react-query";

export async function handleMutateResponse<T>(
    mutateFn: UseMutateAsyncFunction<Response, unknown, T, unknown>,
    handlerParams: T
) {
    try {
        const res = await mutateFn(handlerParams);
        if (res.ok) {
            const response = await res.json();
            return { success: true, data: response.data, response: response };
        }
        if (!res.ok) {
            const msg = (await res.json()).message;
            const error = { message: msg };
            return { success: false, data: null, error };
        }
    } catch (e) {
        return { success: false };
    }
    return { success: false };
}
